module.exports = __webpack_public_path__ + "media/images/google_play-63c6688b.svg";